import { NotificationType } from '@kcftech/prometheus-client';
import {
    GroupSubscribers,
    GroupSubscribersPopup,
} from 'components/notification_subscriptions/GroupSubscribers';
import { NotificationSubscriptionGroup } from 'custom_hooks/data_hooks/data_source/groupedNotificationSubscriptionsDataSource';
import { useInfiniteNotificationSubscriptionsDataSource } from 'custom_hooks/data_hooks/data_source/notificationSubscriptionsDataSource';
import { PopupReturn } from 'custom_hooks/usePopup';
import { getSubscriptionGroupId } from 'pages/Settings/NotificationSubscriptions/shared';
import { useMemo } from 'react';
import { sortBy, uniqueBy } from 'utils/array';

export type NotificationSubscriptionGroupSubscribersProps = Readonly<{
    rowData: NotificationSubscriptionGroup;
}>;

export function NotificationSubscriptionGroupSubscribers({
    rowData,
}: NotificationSubscriptionGroupSubscribersProps) {
    const usersCount = rowData.SubscriberCount;
    return (
        <GroupSubscribers
            popupElement={(popupProps: PopupReturn) => (
                <NotificationSubscriptionGroupSubscribersPopupContent
                    rowData={rowData}
                    popupProps={popupProps}
                />
            )}
            usersCount={usersCount}
        />
    );
}

function NotificationSubscriptionGroupSubscribersPopupContent({
    rowData,
    popupProps,
}: NotificationSubscriptionGroupSubscribersProps & {
    popupProps: PopupReturn;
}) {
    const dataSource = useInfiniteNotificationSubscriptionsDataSource({
        name: 'group-subscribers',
        defaultFilter: {
            isSubscriptionGroupMode: true,
            notificationType: rowData.discriminator as NotificationType,
            corporationId: rowData.Corporation.CorporationId,
            locationId: rowData.Location.LocationId,
            groupId: getSubscriptionGroupId(rowData),
        },
    });
    const { results } = dataSource;
    const sortedAndUniqueUsers = useMemo(
        () =>
            sortBy(
                uniqueBy(
                    results?.map((result) => result.User) ?? [],
                    (user) => user.UserId,
                ),
                (user) => user.UserFirstName.toLowerCase(),
            ),
        [results],
    );

    return (
        <GroupSubscribersPopup
            users={sortedAndUniqueUsers}
            dataSource={dataSource}
            popupProps={popupProps}
        />
    );
}
